import { styled } from '@/style';

export default styled.imgBox``;
